import { Select, outlinedInputClasses, selectClasses, svgIconClasses } from "@mui/material"
import { styled } from "@mui/styles"

export default styled(Select)(({ theme }) => ({
  borderRadius: '8px !important',
  [`& .${svgIconClasses.root}`]: {
    color: theme.palette.primary.main
  },
}));